import { loadRuntimeTheme } from '../../shared/utils/runtimeThemeLoader';

// Load theme configuration at runtime
// This will work for both Electron and web environments
export async function loadWebTheme(): Promise<any> {
  return await loadRuntimeTheme('src/theme-config.yaml', 'web');
}

// For backward compatibility, export a default registry
// This will be replaced by the runtime-loaded theme
export const webThemeRegistry = {};
